export default {"src":"/_next/static/media/donate.e31c1b82.svg","height":520,"width":800,"blurWidth":0,"blurHeight":0};